import { NgModule } from '@angular/core';
import { Gridster, GridsterItem } from 'angular-gridster2';

/** angular-gridster2 v21+ exports standalone components instead of GridsterModule. */
@NgModule({
    imports: [Gridster, GridsterItem],
    exports: [Gridster, GridsterItem],
})
export class GridsterModule {}
